import HubAccounts from './HubAccounts';

export default HubAccounts;
